import * as React from "react";
import { NavLink } from 'react-router-dom';
import MediaQuery from "react-responsive";
import { InverseDropdown } from "./styles"
import { Navbar } from "react-bootstrap";

interface IProps {
    firstName: string,
    lastName: string,
    username: string,
    currentUrl: string,
    courierName: string
}

const LogisticsProviderMenus = (props: IProps) => {
    return (
        <>
            <MediaQuery minWidth={1112}>
                <div className="nkr-menu">
                    <div className='navbar navbar-inverse' style={{ borderRadius: 0, marginBottom: 10 }}>
                        <div className='navbar-header'>
                            <button type='button' className='navbar-toggle' data-toggle='collapse' data-target='.navbar-collapse' style={{ marginTop: 1, height: 18, padding: "5px 18px" }}>
                                <span className='sr-only'>Toggle navigation</span>
                                <span className='icon-bar'></span>
                                <span className='icon-bar'></span>
                                <span className='icon-bar'></span>
                            </button>
                        </div>
                        <div className='navbar-collapse collapse'>
                            <ul className='nav navbar-nav'>
                                <li>
                                    <a href={'/logistics/swaps'}>Logistics</a>
                                </li>
                                <li>
                                    <a href={'/logistics/move-tracker'}>Move Tracker</a>
                                </li>

                      
                                <li className="dropdown">
                                    <a href="#" className="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Reports <span className="caret"></span></a>
                                    <InverseDropdown className="dropdown-menu">
                                        <li>
                                            <NavLink to={'/logistics/upcoming-swap-calls'} activeClassName='active'>Upcoming Swap Calls</NavLink>
                                            <NavLink to={'/logistics/organ-pickup-delivery'} activeClassName='active'>Organ Pick Up and Delivery</NavLink>
                                        </li>
                                    </InverseDropdown>
                                </li>



                                <li className="dropdown">
                                    <a href="#" className="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Welcome, {props.firstName} {props.lastName} <span className="caret"></span></a>
                                    <InverseDropdown className="dropdown-menu">
                                        <li>
                                            <NavLink to={'/manage-account'} activeClassName='active'>Manage Account</NavLink>
                                            <NavLink to={'/logout?next=' + props.currentUrl} activeClassName='active'>Logout</NavLink>
                                        </li>
                                    </InverseDropdown>
                                </li>
                            </ul>

                            <Navbar.Text pullRight style={{ margin: 0 }}>
                                <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} title='' >
                                    {/* {isSuperUser ?
                                            <CenterSelect
                                                centerId={this.props.centerId}
                                                centerList={this.props.centerList}
                                                onClick={this.handleShowDefaultOverlay}
                                            />
                                            :
                                            <Navbar.Text pullRight style={{ paddingTop: 6, paddingBottom: 6, margin: 0 }}>
                                                {this.props.centerAlias}
                                            </Navbar.Text>
                                        }

                                        <div>
                                            <OverlayTrigger container={this} placement='bottom' trigger={['hover', 'focus']} overlay={this.getOverlay()} rootClose={!this.state.defaultOverlayShown} defaultOverlayShown={this.state.defaultOverlayShown} animation={true} >
                                                <div>
                                                    <Label bsStyle={this.props.notifications > 0 ? 'success' : 'default'} style={{ marginLeft: 5, padding: 5 }} onClick={this.props.onShowNotifications}>{this.props.notifications}</Label>
                                                </div>
                                            </OverlayTrigger>
                                        </div> */}
                                    <Navbar.Text pullRight style={{ paddingTop: 6, paddingBottom: 6, margin: 0 }}>
                                        {props.courierName}
                                    </Navbar.Text>
                                </div>
                            </Navbar.Text>
                        </div>
                    </div>
                </div>
            </MediaQuery>
        </>
    );
}

export default LogisticsProviderMenus;